import React from 'react';
import PropTypes from 'prop-types';

const DescriptionOfCapability = ({ util }) => (
  <div>
    {
      util.descriptionOfCapability &&
      <div><strong>Description of Capability:</strong> {util.descriptionOfCapability}</div>
    }
  </div>
);

DescriptionOfCapability.propTypes = {
  util: PropTypes.object,
};

export default DescriptionOfCapability;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailUtilities/SubUtilityDetailsSections/DescriptionOfCapability.js